import { isClientDeploymentEnv, sanitizeBaseUrl } from '@reward-platform/utils'
import { isAviosThemeWhitelabelAllowed, isWhitelabelHost } from './whitelabel'

export const AVIOS_DOMAIN = 'avios.com'
export const AVIOS_DEV_LB_DOMAIN_SUFFIX = 'avios.reward-platform'
const AVIOS_DOMAIN_DEFAULT_BASE_PATH = '/spend-avios/rewards'

export const AVIOS_HOSTS = {
  prd: 'www.avios.com',
  stg: 'stg.avios.com',
  tst: 'tst.avios.com',
}

const getAviosEnvHost = () => {
  if (isClientDeploymentEnv('prd')) {
    return AVIOS_HOSTS.prd
  }
  if (isClientDeploymentEnv('stg')) {
    return AVIOS_HOSTS.stg
  }
  return AVIOS_HOSTS.tst
}

export const getAviosBasePathEnvValue = () => {
  // Temporary ignore for the legacy build
  if (process.env.NEXT_PUBLIC_PLATFORM_TYPE === 'whitelabel') {
    return ''
  }

  const basePathValue = process.env.NEXT_PUBLIC_AVIOS_BASE_PATH
  if (!basePathValue) {
    return ''
  }
  return basePathValue
}

export const getAviosBaseUrl = (locale?: string) => {
  const host = getAviosEnvHost()
  const basePath = getAviosBasePathEnvValue() || AVIOS_DOMAIN_DEFAULT_BASE_PATH
  const localePath = locale ? `/${locale}` : ''
  return sanitizeBaseUrl(host + localePath + basePath)
}

export const isAviosHostValid = (host?: string) => {
  if (isAviosThemeWhitelabelAllowed(host)) {
    return true
  }

  // Allow testing LB directly url for avios build in dev and tst env
  if (isClientDeploymentEnv(['dev', 'tst']) && !!host?.includes(AVIOS_DEV_LB_DOMAIN_SUFFIX)) {
    return true
  }

  // Update first condition to do stricter checks using environment host?
  return !!host?.endsWith(AVIOS_DOMAIN)
}

// returns undefined if not valid host
export const getValidBasePathForHost = (host?: string) => {
  const isWhitelabel = isWhitelabelHost(host)
  const isAviosWhitelabel = isAviosThemeWhitelabelAllowed(host)

  // allow base path if defined for local testing
  const shouldRemoveBasePath = isAviosWhitelabel && !isClientDeploymentEnv(['local', 'dev'])

  // return no base path if whitelabel or testing avios theme
  if (isWhitelabel || shouldRemoveBasePath) {
    return undefined
  }

  if (isAviosHostValid(host)) {
    return getAviosBasePathEnvValue()
  }
  return undefined
}
